import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';

import '@/core/tokens/tokens.css';
import '@/core/tokens/base.css';
import '@/styles/delivery.css';

import App from './App.vue';
import { router } from './router';
import { installPermissionDirectives } from '@/core';
import { getContractDrift } from '@/api/http';
import { useAppStore } from '@/stores/app';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(ElementPlus, { locale: zhCn, size: 'small' });
installPermissionDirectives(app);

// 端标识驱动主题；主题取展示用 VITE_APP_THEME（VITE_APP_END 必须留在后端 endBinding 封闭集内，
// 本端为 ADMIN，不能拿它当主题键）。?static 关闭动效
document.documentElement.setAttribute(
  'data-end',
  import.meta.env.VITE_APP_THEME || import.meta.env.VITE_APP_END || 'ADMIN',
);
if (useAppStore(pinia).staticMode) {
  document.documentElement.classList.add('static');
}

app.mount('#app');

/**
 * 联调取证钩子（仅 dev）：控制台 `__contract.drift()` 读契约漂移。
 * 生产构建由 `import.meta.env.DEV` 静态剔除，不暴露内部取证清单。
 */
if (import.meta.env.DEV) {
  (window as unknown as Record<string, unknown>).__contract = { drift: getContractDrift };
}
